import { createTracker, newSessionId } from 'uhs-finder.metrics';
import { initRequestForm, subscribeReturn } from 'uhs-request.form';
import { loadPayload } from 'uhs-finder.payload';

// One listener at a time: the theme editor re-runs boot for a reloaded section, and two listeners
// would open the dialog twice off a single click.
let openListener = null;

export function initRequest(root) {
  const dialog = root.querySelector('[data-uhs-request-dialog]');
  const sessionId = subscribeReturn()?.sessionId || newSessionId();
  const d = root.dataset;

  const openDialog = () => {
    if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
  };

  // Every event and the request itself say they never went through the finder, so the server
  // keeps them out of that funnel.
  const track = createTracker(d.metricsUrl || '', sessionId);
  const form = initRequestForm(root, {
    sessionId,
    track: (event, fields) => track(event, { source: 'product', ...fields }),
    copy: {
      requestUrl: d.requestUrl || '/apps/uhs/finder-request',
      requestSuccess: d.requestSuccess || 'Got it - thanks.',
      requestError: d.requestError || "That didn't send. Please try again.",
      requestThrottled: d.requestThrottled || "You've already sent us a few. Try again later.",
      requestEmailInvalid: d.requestEmailInvalid || "That email doesn't look right. Fix it or clear it.",
      requestSuccessSubscribed: d.requestSuccessSubscribed || "Request sent - and you're on the list.",
      requestSuggestions: d.requestSuggestions || 'Is it one of these?',
      // `??`, not `||`: a setting cleared to blank renders no subline.
      requestSuggestionsNote: d.requestSuggestionsNote ?? "These are close matches to what you typed. Check the model name before you order. Either way, we've got your request.",
      leadTimeMade: d.leadTimeMade || '',
      soldOut: d.soldOutNote || 'Sold out right now - check back soon.',
    },
    payload: () => loadPayload(d.sectionUrl),
    context: () => ({ source: 'product' }),
    show: openDialog,
  });
  if (!form) return;

  if (openListener) document.removeEventListener('click', openListener);

  openListener = event => {
    if (!event.target.closest?.('[data-uhs-request-open]')) return;
    // The editor replaces section markup wholesale; a ctx whose dialog is no
    // longer in the document must not answer for the one that is.
    if (!root.isConnected) return;
    form.open();
  };

  document.addEventListener('click', openListener);
}

function boot(scope) {
  const root = scope.querySelector('[data-uhs-request]');
  if (!root) return;

  try {
    initRequest(root);
  } catch (err) {
    console.error('UHS request init failed:', err);
  }
}

// ES modules are deferred, so the DOM is already parsed.
boot(document);

document.addEventListener('shopify:section:load', event => {
  if (event.target && typeof event.target.querySelector === 'function') boot(event.target);
});
